
import Vue from 'vue'
import { RATING_COLORS, MAX_RATING } from '@/constants'

export default Vue.extend({
  name: 'fo-mark',
  props: {
    value: {
      type: Number,
      required: true,
    },
    dataId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    RATING_COLORS,
    MAX_RATING,
    localValue: 0,
  }),
  beforeMount() {
    this.localValue = this.value
  },
  watch: {
    localValue(next) {
      this.$emit('input', next)
    },
    value(next) {
      if (next !== this.localValue) {
        this.localValue = next
      }
    },
  },
})
